import { C } from '../tokens';

export function Spinner({ label = 'Загрузка...' }: { label?: string }) {
  return (
    <div style={{ padding: 32, display: 'grid', placeItems: 'center', gap: 10 }}>
      <span style={{ color: C.bl, fontSize: 24, animation: 'sp .9s linear infinite', display: 'inline-block' }}>↻</span>
      <span style={{ color: C.sub, fontSize: 12 }}>{label}</span>
    </div>
  );
}
